import { createAsyncThunk, isRejectedWithValue } from '@reduxjs/toolkit'
import { getExceptionPayload } from '../../../lib/utils/get-exception-payload'
import { ApiRequestErrorType } from '../../../types/api/api.types'
import { IncomeService } from '../../../services/api/income.service'

const incomeService = new IncomeService()

export const getSubscriptionTotalIncomeThunk = createAsyncThunk(
  'transaction/income/subscription-income-total',
  async (token: string) => {
    try {
      const response = await incomeService.getSubscriptionTotalIncome(token)
      return response.data
    } catch (err) {
      return isRejectedWithValue(getExceptionPayload(err) as ApiRequestErrorType)
    }
  },
)
